<template>
  <div>
    <nav-bar/>
    <slot/>
  </div>
</template>

<script>
    import Navbar from "../components/core/Navbar";
    import Footer from "../components/core/Footer";

    export default {
        name: "Default",
        components: {
            'nav-bar': Navbar,
            'nav-footer': Footer
        }
    }
</script>

<style scoped>
</style>
